import PanelBox from '../../components/PanelBox';
import React from 'react'
import { connect } from "react-redux";
import СaseTableClient from "./caseTableClient";
import СaseTableStaff from "./caseTableStaff";
// import CaseUpload from "./caseUpload";
import CaseNew from "./caseNew";

import { Card, Upload, Table, Form, Input, Tooltip, Icon, Cascader, Select, Row, Col, Checkbox, Button, notification } from 'antd';

const FormItem = Form.Item;

const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}

class Form1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
    };
  }

  render() {
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    const formItemFiels = {
      labelCol: { span: 10 },
      wrapperCol: { span: 6 },
    };
    
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 14,
          offset: 0,
        },
        sm: {
          span: 14,
          offset: 10,
        },
      },
    };


    return (
      <div>
        <CaseNew/>
        { this.props.user.is_client ? <СaseTableClient/> : <СaseTableStaff/>}
      </div>
    );
  }
}

export default connect(mapStateToProps)(Form1)


// WEBPACK FOOTER //
// ./src/views/Cases/index.jsx